module.exports = __webpack_public_path__ + "media/images/recipes/bonvite_erwtensoep-6229f5cc2f282cf4df5787c034c6c593.pdf";